export default __webpack_public_path__ + "static/media/chat_options.c689ce33.svg";